import React from 'react'
import { Button, Input, Stack, Text } from '@/components/lib'

/**
 * Send-a-code / enter-the-code controls for verifying a contact detail. Shared
 * by the consent form and public questionnaires; drive it with the
 * `useContactVerification` hook.
 */
export default function VerificationBox ({ vs, contactValue, onRequestCode, onCodeChange, onVerify }) {
  if (!contactValue) return null
  return (
    <Stack gap={2} mt={2}>
      {vs.status === 'idle' && (
        <Button
          w='100%'
          colorPalette='primary'
          onClick={onRequestCode}
          isDisabled={vs.status === 'sending'}
        >
          Send verification code
        </Button>
      )}

      {(vs.status === 'sent' ||
        vs.status === 'verifying' ||
        vs.status === 'failed') && (
          <Stack direction='row' gap={2} alignItems='center'>
            <Input
              bg='bg.surface'
              size='sm'
              maxW='120px'
              placeholder='000000'
              value={vs.code}
              maxLength={6}
              onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 6)
                onCodeChange(val)
              }}
              isDisabled={vs.status === 'verifying'}
            />
            <Button
              size='sm'
              colorPalette='primary'
              onClick={onVerify}
              isLoading={vs.status === 'verifying'}
              isDisabled={vs.code.length !== 6}
            >
              Verify
            </Button>
            {vs.remainingSeconds > 0
              ? (
                <Text fontSize='xs' color='fg.muted'>
                  Resend in {vs.remainingSeconds}s
                </Text>
                )
              : (
                <Button
                  size='xs'
                  variant='ghost'
                  onClick={onRequestCode}
                >
                  Resend
                </Button>
                )}
          </Stack>
      )}

      {vs.error && (
        <Text fontSize='xs' color='red.500'>
          {vs.error}
        </Text>
      )}
    </Stack>
  )
}
